<template>
  <header class="site-header">
    <div class="site-header__inner">
      <div class="site-header__brand">
        <router-link to="/home" class="brand-link">
          <span class="brand-mark">
            <img src="@/assets/image/home/smart-cube-mark.png" alt="智训立方" />
          </span>
          <span class="brand-copy">
            <strong>智训立方</strong>
            <em>Smart Training Cube</em>
          </span>
        </router-link>
      </div>

      <nav class="site-header__nav">
        <router-link to="/home">首页</router-link>
        <router-link to="/more">经典案例</router-link>       
        <a @click="handleStudentClick">我的课程</a>
        <router-link to="/dev">数字化开发</router-link>
        <router-link to="/help">帮助中心</router-link>
        <router-link to="/product">关于我们</router-link>
      </nav>

      <div class="site-header__action">
        <button v-if="name" class="user-pill" @click="handleLoginOut">
          <span class="user-dot"></span>
          Hi，{{ name }}
        </button>
        <button v-else class="login-pill" @click="showLoginModal">登录</button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
import permissionMixin from "@/mixins/permission.js";

export default {
  name: "AppHeader",
  mixins: [permissionMixin],
  computed: {
    ...mapState(["name", "roles"]),
  },
  methods: {
    handleStudentClick() {
      if (this.name) {
        this.navigateByRole();
      } else {
        this.showLoginModal();
      }
    },
    showLoginModal() {
      this.$emit("show-login");
      this.$router.replace("/login");
    },
    handleLoginOut() {
      this.$confirm("是否退出当前账号？", "退出登录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("LogOut");
          this.$router.replace("/login");
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(210, 224, 245, 0.82);
  box-shadow: 0 10px 30px rgba(15, 43, 90, 0.045);
}

.site-header__inner {
  width: min(1400px, calc(100% - 56px));
  height: 74px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}

.site-header__brand {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}

.brand-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.brand-mark {
  position: relative;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  overflow: hidden;
  flex: 0 0 auto;
  background: linear-gradient(145deg, #071b38, #0e315d);
  box-shadow:
    0 14px 30px rgba(15, 47, 95, 0.20),
    0 0 0 1px rgba(34, 201, 255, 0.16);
}

.brand-mark::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.18), transparent 42%, rgba(34, 201, 255, 0.12));
  pointer-events: none;
}

.brand-mark img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.brand-copy {
  display: grid;
  gap: 4px;
  line-height: 1;
}

.brand-copy strong {
  color: #102044;
  font-size: 24px;
  font-weight: 950;
  letter-spacing: 0.025em;
}

.brand-copy em {
  color: #5f708f;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.085em;
  text-transform: none;
}

.site-header__nav {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.site-header__nav a {
  position: relative;
  padding: 8px 14px;
  border-radius: 999px;
  color: #1f2c46;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.025em;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.22s ease;
}

.site-header__nav a::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 4px;
  width: 16px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, #2f6fed, #22c9ff);
  transform: translateX(-50%) scaleX(0);
  transform-origin: center;
  opacity: 0;
  transition: all 0.22s ease;
}

.site-header__nav a:hover,
.site-header__nav a.router-link-exact-active {
  color: var(--primary-color);
  background: rgba(47, 111, 237, 0.09);
}

.site-header__nav a:hover::after,
.site-header__nav a.router-link-exact-active::after {
  transform: translateX(-50%) scaleX(1);
  opacity: 1;
}

.site-header__action {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}

.login-pill,
.user-pill {
  border: none;
  cursor: pointer;
  min-width: 92px;
  height: 36px;
  padding: 0 18px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.025em;
  transition: all 0.22s ease;
}

.login-pill {
  color: #fff;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color) 64%, var(--tech-cyan));
  box-shadow: 0 10px 22px rgba(21, 87, 216, 0.20);
}

.login-pill:hover,
.user-pill:hover {
  transform: translateY(-1px);
}

.user-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--brand-blue-deep);
  background: rgba(248, 250, 252, 0.92);
  border: 1px solid rgba(194, 211, 238, 0.88);
}

.user-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.12);
}

@media screen and (max-width: 1024px) {
  .site-header__inner {
    width: min(100% - 28px, 100%);
    height: auto;
    min-height: 72px;
    flex-wrap: wrap;
    padding: 10px 0;
  }

  .brand-mark {
    width: 46px;
    height: 46px;
  }

  .brand-copy strong {
    font-size: 21px;
  }

  .site-header__nav {
    order: 3;
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 4px;
  }

  .site-header__nav a {
    white-space: nowrap;
    font-size: 13px;
    padding: 8px 12px;
  }
}

@media screen and (max-width: 640px) {
  .brand-copy em {
    display: none;
  }

  .site-header__nav a:nth-child(5) {
    display: none;
  }

  .login-pill,
  .user-pill {
    min-width: auto;
    height: 36px;
    padding: 0 14px;
    font-size: 13px;
  }
}
</style>
